import { render, staticRenderFns } from "./EntitiesListEventDetail.vue?vue&type=template&id=27e054ad"
import script from "./EntitiesListEventDetail.vue?vue&type=script&lang=js"
export * from "./EntitiesListEventDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports